// AD-2747 (Maria, 23 October 2026): the message under the email box when the address already belongs to someone on the
// child's profile. On a non-parental contact form (every allowed priority 3 or more) that contact is not changed and
// the new contact is added without the email address; on any other form the contact is updated, as before.

const priorityKey = component => (component?.fieldKey ?? component?.key ?? '').toLowerCase();

export const isNonParentalContactForm = (schema = []) => {
    const priority = schema.find(component => priorityKey(component) === 'parentpriority');
    const allowed = priority?.validation?.allowedValues;
    return Array.isArray(allowed) && allowed.length > 0 && allowed.every(value => Number(value) >= 3);
};

export const existingEmailMessage = (schema, studentForename) => (isNonParentalContactForm(schema)
    ? `This email address already belongs to someone on ${studentForename ? `${studentForename}'s` : 'the child\'s'} profile. The new contact will be added without an email address.`
    : 'This email already exists for this student. Submitting will update an existing contact.');
